// src/utils/request.js
import axios from 'axios';

// 创建 axios 实例
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // 从环境变量读取 API 基础路径
  timeout: 5000, // 请求超时时间
});

// 请求拦截器（可选）
request.interceptors.request.use(
  (config) => {
    // 在发送请求前做一些处理，例如添加 token
    // config.headers['Authorization'] = 'Bearer ' + getToken();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器（可选）
request.interceptors.response.use(
  (response) => {
    // 对响应数据做一些处理
    return response.data;
  },
  (error) => {
    // 对错误响应做一些处理
    return Promise.reject(error);
  }
);

export default request;